import { getImageFromAssetFolder } from "../utils/assets";

const Branding = () => {
  return (
    <div
      className="flex cursor-pointer"
      onClick={() => window.open("/", "_self")}
    >
      <img width={100} src={getImageFromAssetFolder("logo_text.png")} />
    </div>
  );
};

export default Branding;
